export default class DtoAccountSettings {
    constructor(obj) {
        this.login = obj.login
        this.parameter = obj.parameter
        this.updateDate = obj.updateDate
        this.value = obj.value
    }
}